import axios from "./axiosinstance";

const DashboardApi = {

  /* =========================
     COMMON DASHBOARD
  ========================= */

  getDashboardStats: () =>
    axios.get(
      "/dashboards/stats"
    ),


  /* =========================
     TESTER DASHBOARD
  ========================= */

  getTesterDashboard: () =>
    axios.get(
      "/dashboards/tester"
    ),


  /* =========================
     SALES DISPOSITION LIST
  ========================= */

  salesDispositionList: (params) =>
    axios.get(
      "/dashboards/sales-disposition-list",
      {
        params,
      }
    ),

};

export default DashboardApi;